define('modules/editor/behaviours/has_page_margins',['require','exports','module','../models/editorstate','../views/controls/page_margin'],function(require, exports, module){
  "use strict";
  var EditorState = require("../models/editorstate"),
      PageMarginView = require("../views/controls/page_margin");

  /**
  HasPageMargins - View behaviour
  Displays/hides page content margins
  **/
  var HasPageMargins = {
    mixed: function(klass, proto){
      proto.initialize = _.wrap(proto.initialize || _.identity, this._marginsInit);
      proto.onRender = _.wrap(proto.onRender || _.identity, this._marginsOnRender);
      proto.onRemove = _.wrap(proto.onRemove || _.identity, this._marginsOnRemove);
    },
    _marginsInit: function(init){
      // console.log('Init margins');
      init.apply(this, _.rest(arguments));
      this.listenTo(EditorState, "change:displayMargins", function(model, shouldDisplay){
        this._toggleMargins(shouldDisplay);
      });
    },
    _marginsOnRender: function(render){
      render.apply(this, _.rest(arguments));
      this._deleteMargins();
      // console.log('Render margins');
      this._createMargins();
      this._toggleMargins(EditorState.get("displayMargins"));
      this._watchScroll();
    },
    _marginsOnRemove: function(remove){
      // console.log('Removing margins');
      this._deleteMargins();
      this._unwatchScroll();
      remove.apply(this, _.rest(arguments));
    },
    _createMargins: function(){
      if(!this._pageMargins){
        this._pageMargins = {
          left: new PageMarginView({ side: "left" }),
          right: new PageMarginView({ side: "right" })
        };

        this.$el.prepend(this._pageMargins.left.render().$el);
        this.$el.prepend(this._pageMargins.right.render().$el);

        //listen to page margin events and forward them
        this.listenTo(this._pageMargins.left, "margin:resize", function(data){
          EditorState.getVariant().adjustPageWidth(data.delta);
        });
        this.listenTo(this._pageMargins.right, "margin:resize", function(data){
          EditorState.getVariant().adjustPageWidth(data.delta);
        });
      }
    },

    _toggleMargins: function(shouldDisplay){
      // console.log("Display margins", shouldDisplay);
      if(this._pageMargins){
        this._pageMargins.left.$el.toggle(shouldDisplay);
        this._pageMargins.right.$el.toggle(shouldDisplay);
        this._positionHandles();
      }
    },

    _deleteMargins: function(){
      if(this._pageMargins){
        this._pageMargins.left.remove();
        this._pageMargins.right.remove();
        delete this._pageMargins;
      }
    },
    _watchScroll: function(){
      $(window).on("scroll", _.debounce(_.bind(this._positionHandles, this), 100));
    },
    _positionHandles: function(){
      var leftHandle = this._pageMargins.left.$el.find(".handle"),
          rightHandle = this._pageMargins.right.$el.find(".handle"),
          scrollTop = $(window).scrollTop();

      leftHandle.animate({ top: scrollTop }, 200);
      rightHandle.animate({ top: scrollTop }, 200);

      if(scrollTop <= 0){
        leftHandle.css("top", 0);
        rightHandle.css("top", 0);
      }
    },
    _unwatchScroll: function(){
      $(window).off("scroll");
    }
  };

  module.exports = HasPageMargins;
});
